<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="centerDialogVisible"
      :width="width"
      :center="center"
      :fullscreen="fullscreen"
      :modal="modal"
      :close-on-click-modal="closeOnClickModal"
      :show-close="showClose"
      :destroy-on-close="destroyOnClose"
      :top="top"
      custom-class="customWidth"
    >
    <slot name="title" class="dialog-footer">
      
    </slot>

    <div :style="{'height':`${height}`}">
      <el-scrollbar style="height:100%">
        <slot name="content"></slot>
        <slot name="footer"></slot>
      </el-scrollbar>
    </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="$emit('submitDetermine')" >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Dialog',
  props: {
    title: {
      type: String,
      dafault: '',
      // required: true,
    },
    width: {
      type: String,
      dafault: '50%',
    },
    height:{
      type:String,
      dafault:'300px'
    },
    fullscreen: { //是否为全屏 Dialog
      type: Boolean,
      dafault: false,
    },
    modal: {//是否需要遮罩层
      type: Boolean,
      dafault: false,
    },
    closeOnClickModal: { //是否可以通过点击 modal 关闭 Dialog
      type: Boolean,
      dafault: false,
    },
    showClose: { //是否显示关闭按钮
      type: Boolean,
      dafault: true,
    },
    center: { //是否对头部和底部采用居中布局
      type: Boolean,
      dafault: true,
    },
    destroyOnClose: { //关闭时销毁 Dialog 中的元素
      type: Boolean,
      dafault: false,
    },
    top: { //Dialog CSS 中的 margin-top 值
      type: String,
      dafault: '15vh',
    },
  },
  data() {
    return {
      centerDialogVisible: false,
    }
  },
  methods: {
    showDiaog() {
      this.centerDialogVisible = !this.centerDialogVisible
    },
  },
}
</script>

<style lang="less" scope>
    
.eldialog {
  .customWidth {
    height: 50vh;

  }
  
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
}
</style>
// <style lang="less">
//   .el-scrollbar__wrap {
//     overflow-x: hidden;
//   }
// </style>